<template>
  <b-card class="mb-2">
    <!-- Row 1: Advertiser ID and Access Token -->
    <b-row class="mb-2">
      <b-col
        md="6"
        sm="12"
        class="mb-2"
      >
        <b-form-group
          label="Advertiser Account"
          class="mb-0"
        >
          <div class="d-flex">
            <b-form-input
              :value="manualAdvertiserId"
              placeholder="Enter Advertiser ID (e.g., 12345)"
              class="mr-1"
              type="text"
              @input="$emit('manual-advertiser-input', $event)"
            />
            <b-button
              v-if="manualAdvertiserId"
              v-b-tooltip.hover
              variant="outline-primary"
              size="sm"
              :disabled="savingDefault"
              title="Save as default advertiser ID"
              @click="$emit('save-default-advertiser')"
            >
              <b-spinner
                v-if="savingDefault"
                small
                class="mr-1"
              />
              <feather-icon
                v-else
                icon="BookmarkIcon"
                size="16"
              />
            </b-button>
          </div>
        </b-form-group>
      </b-col>
      <!-- Access Token field removed - authentication handled by backend -->
    </b-row>

    <!-- Row 2: TikTok Task ID and Status Filter -->
    <b-row class="mb-2">
      <b-col
        md="6"
        sm="12"
        class="mb-2"
      >
        <b-form-group
          label="TikTok Task ID"
          class="mb-0"
        >
          <b-form-input
            :value="filters.tiktokTaskId"
            placeholder="Enter TikTok Task ID to search"
            @input="$emit('filter-change', { ...filters, tiktokTaskId: $event })"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="6"
        sm="12"
        class="mb-2"
      >
        <b-form-group
          label="Status Filter"
          class="mb-0"
        >
          <b-form-select
            :value="filters.status"
            :options="statusOptions"
            @change="$emit('filter-change', { ...filters, status: $event })"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Row 3: Clear and Debug buttons -->
    <b-row>
      <b-col
        md="6"
        sm="12"
        class="mb-1"
      >
        <b-button
          variant="outline-secondary"
          class="w-100"
          @click="$emit('clear-filters')"
        >
          <feather-icon
            icon="XIcon"
            class="mr-1"
          />
          Clear Filters
        </b-button>
      </b-col>
      <b-col
        md="6"
        sm="12"
        class="mb-1"
      >
        <b-button
          variant="outline-info"
          class="w-100"
          @click="$emit('debug-advertiser-state')"
        >
          <feather-icon
            icon="InfoIcon"
            class="mr-1"
          />
          Debug
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BButton,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BFormInput,
  BSpinner,
  VBTooltip,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

export default {
  name: 'TaskLogFilters',
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BSpinner,
    FeatherIcon,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    manualAdvertiserId: {
      type: String,
      default: '',
    },
    filters: {
      type: Object,
      required: true,
    },
    savingDefault: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    statusOptions() {
      return [
        { value: '', text: 'All Status' },
        { value: 'PROCESSING', text: 'Processing' },
        { value: 'COMPLETED', text: 'Completed' },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
// Purple theme for outline-primary buttons
.btn-outline-primary {
  color: #6e44ff !important;
  border-color: #6e44ff !important;

  &:hover:not(:disabled) {
    background-color: #6e44ff !important;
    border-color: #6e44ff !important;
    color: white !important;
  }

  &:focus,
  &:focus:not(:disabled) {
    background-color: #6e44ff !important;
    border-color: #6e44ff !important;
    color: white !important;
    box-shadow: 0 0 0 0.2rem rgba(110, 68, 255, 0.25) !important;
  }

  &:active,
  &:active:not(:disabled) {
    background-color: #5a3acc !important;
    border-color: #5a3acc !important;
    color: white !important;
  }
}
</style>
